export default __webpack_public_path__ + "static/media/documentListIcon.64e08feb.svg";